import React, { useState, useEffect, useRef } from "react";
import * as Utils from "core/common/utils";
import { setCurrentBusiness } from "core/store/actionCreators";
import useStore from "core/custom-hooks/useStore";
import { SUBBUSINESS_ID_LOCAL_STORAGE_KEY } from "core/common/constants/localstorage";
import clsx from "clsx";
import * as TagManager from "core/common/seo/tagManager";
import { sub } from "date-fns";

const SubBusinesses = ({ shouldShowCurrentBusiness, mainClass = "", isMobile, close }) => {
    const { state, dispatch, businessRepository } = useStore();
    const { business } = state;
    const { sub_bussnisses, business_id: currentBusinessId } = business;
    const currentBusinessIdRef = useRef(currentBusinessId);
    const maxDesktopSubBusinesses = 4;


    let subBusinesses = sub_bussnisses ? [...sub_bussnisses] : [];
    if (!shouldShowCurrentBusiness) {
        subBusinesses = subBusinesses.filter(x => x.business_id !== currentBusinessId);
    }

    const [shouldHideSubBusinesses, setShouldHideSubBusinesses] = useState(!isMobile && subBusinesses.length > maxDesktopSubBusinesses);

    if (shouldHideSubBusinesses) {
        subBusinesses = subBusinesses
        .sort(x => x.business_id === currentBusinessId ? -1 : 1)
        .slice(0, maxDesktopSubBusinesses);
    }

    useEffect(() => {
        if (currentBusinessIdRef.current !== business.business_id) {
            typeof (close) === "function" && close();
        }

    }, [business]);

    return (
        <ul className={mainClass}>
            {
                subBusinesses
                .sort(x => x.business_id === currentBusinessId ? -1 : 1)
                .map((x, index) => {
                    const { name, business_id } = x;
                    return (
                        <li key={`SubBusinesses_${index}`} className={clsx(
                            business_id === currentBusinessId && "selected",
                          //  x.subCustStatus !== 'פעיל' && "customer_sidebar_not_active"
                        )}>
                            <a href="javascript:void(0)" onClick={(e) => {
                                Utils.loadingWrapper(dispatch, async () => {
                                    typeof (close) === "function" && close();
                                    e.preventDefault();
                                    const { data: responseData } = await businessRepository.get(business_id);
                                    const { data } = responseData || {};
                                    if (Utils.isSuccessfulRequest(dispatch, responseData, true)) {
                                        TagManager.sendBusinessId(business_id);
                                        localStorage.setItem(SUBBUSINESS_ID_LOCAL_STORAGE_KEY, business_id);
                                        localStorage.removeItem("link-ofir")
                                        dispatch(setCurrentBusiness(data));
                                    }
                                });
                            }}>
                                {name}
                            </a>
                        </li>
                    );
                })
            }

            {
                shouldHideSubBusinesses &&
                <li>
                    <a href="javascript:void(0)" onClick={(e) => {
                        e.preventDefault();
                        setShouldHideSubBusinesses(false);
                    }} className="read-more">
                        עוד {" "}
                        <i className="fa fa-angle-double-down"></i>
                    </a>
                </li>
            }
        </ul>
    );
}

export default SubBusinesses;